import {ScaleLoader} from "react-spinners";

const Loader = ({className}) => (
    <div className={ className + ' inset-0 bg-black/40 flex items-center justify-center'}>
        <div className={'flex flex-col justify-center items-center'}>
            <p className={'py-1.5 text-white'}> Please wait...</p>
            <ScaleLoader color="#fff" />
        </div>
    </div>
);

export default Loader;